import type StatusObject from '@/classes/SubmissionStatuses/StatusObject'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import {
	type SubmissionAction,
	type SubmissionStatus,
} from '@/classes/SubmissionStatuses/types'

export class UnknownStatus implements StatusObject {
	submissionStatus: SubmissionStatus

	constructor(submissionStatus: SubmissionStatus) {
		this.submissionStatus = submissionStatus
	}

	getVendorName(): string {
		return ''
	}

	getUpdatedAt() {
		return this.submissionStatus.updatedAt
	}

	getActions(): Array<SubmissionAction> {
		return []
	}

	getStatusText() {
		return 'Unknown Status'
	}

	getToolTipText() {
		return {
			title: 'Unknown Status',
			body: 'Status can’t be determined at this time. Please contact salesstudio@precoa.com for assistance.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.ERROR
	}
}
